export enum EnumPeriodoCalculo {
  Diario = 1,
  Mensual = 2,
  Trimestral = 3,
  Anual = 4,
  Horario = 5,
  HorarioPlano = 6,
  DiarioPlano = 7,
  CuartoHorario = 8,
  CuartoHorarioPlano = 9
}
